import { HttpDataService } from '../../../shared/http/http-data.service';

import { Injectable } from '@angular/core';

@Injectable()
export class DeskOverviewDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getPictures(pictureIds:number[]):Promise<string[]> {
    if (!pictureIds?.length) {
      return Promise.resolve([]);
    }

    return this.httpDataService.doGET(
      `rest/document/urls?ids=${pictureIds.join(',')}`,
      undefined,
      undefined,
      'Error loading pictures'
    );
  }
}